import React, {FC, useEffect, useState} from 'react'
import {Link, useNavigate} from 'react-router-dom'
import {PageTitle} from '../../../_metronic/layout/core'
import {fetchData, getEncryptedRoute, toasterrormsg, toastsuccessmsg, useMenuIdPermissions} from '../../../reusable'
import {ToastContainer} from 'react-toastify'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {faMinus, faPlus} from '@fortawesome/free-solid-svg-icons'
import Swal from 'sweetalert2'
import {toAbsoluteUrl} from '../../../_metronic/helpers'
import { Tr } from '../../../_metronic/i18n/Tr'


interface GuestInfoHeaderProps {
  bookingId: string // Assuming bookingId is of type string, adjust as needed
  bookingdetailId: string // Assuming bookingId is of type string, adjust as needed
}

const GuestInfo: React.FC<GuestInfoHeaderProps> = ({bookingId, bookingdetailId}) => {
  let t = Tr()
      const { menuId} = useMenuIdPermissions()


  const [loading, setLoading] = useState(false)
  const [disable, setDisable] = useState(false)
  const [people, setPeople] = useState('')

  const [guestInfo, setGuestInfo] = useState<any>([
    {name: '', surname: '', contactNumber: '', email: '', aggreement: ''},
  ])

  const [fromTime, setFromTime] = useState('')
  const [toTime, setToTime] = useState('')
  const [quantity, setQuanity] = useState('')
  const [bookingType, setBookingType] = useState('')
  const [statusList] = useState([
    {value: '0', label: 'Pending'},
    {value: '1', label: 'Approved'},
    {value: '2', label: 'Rejected'},
    {value: '3', label: 'Cancelled'},
    // {value: '4', label: 'Completed'},
  ]) as any

  const [renableSpaceList, setRentableSpaceList] = useState([])
  const [spacerentalId, setSpaceRentalId] = useState('')
  const [rentableSpaceId, setRentableSpaceId] = useState('')
  const [selectedStatus, setSelectedStatus] = useState<any>([])
  const [selectedRentableSpace, setSelectedRentableSpace] = useState<any>([])
  const [detailBookingId, setDetailBookingId] = useState('')
  const [maxPeople, setMaxPeople] = useState('')

  const removeGuest = (id: any, index: number) => {
    if (id == '' || id == undefined || id == null) {
      const updateGuestInfo = [...guestInfo]

      // Remove the element at the specified index
      updateGuestInfo.splice(index, 1)

      // Update the state with the new array
      setGuestInfo(updateGuestInfo)
    } else {
      var tmp2 = sessionStorage.getItem('admin')
      // Step 2: Check if the item is not null
      if (tmp2) {
        // Step 3: Parse the JSON string
        var adminData = JSON.parse(tmp2)
        // Step 4: Access the adminId
        var adminId = adminData.adminId
      }
      Swal.fire({
        title: t('Are you sure?'),
        text: t('You Want To Delete this row!'),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: t('Ok'), 
        cancelButtonText: t('Cancel'),
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            var param: any = {
              adminId: adminId,
              bookingId: bookingId,
              bookingdetailId: bookingdetailId,
              guestId: id,
            }
            const response = await fetchData('admin/deleteguest', param)

            if (response.status == '200') {
              const updatedAccommodation = [...guestInfo]
              updatedAccommodation.splice(index, 1)
              setGuestInfo(updatedAccommodation)
              toastsuccessmsg('Deleted Successfully')
            } else {
              toasterrormsg(response.message)
            }
          } catch (error) {
            toasterrormsg('An error occurred while processing your request.')
          }
        }
      })
    }
  }
  // const formatDate = (date: any) => {
  //   if (date == null || date == '') {
  //     var today: any = new Date()
  //     var date: any = moment(today).format('yyyy-MM-DD')
  //     return date
  //   }

  //   return moment(date).format('yyyy-MM-DD')
  // }

  const addGuest = () => {
    const newGuest = {name: '', surname: '', contactNumber: '', email: '', aggreement: ''}
    setGuestInfo([...guestInfo, newGuest])
  }

  const BookingListApiCall = async () => {
    var param: any = {
      bookingId: bookingId,
      categoryId: '4',
    }

    var res = await fetchData('admin/bookingdetail', param)

    if (res.status == '200') {
      var data = res.data[0]

      setDetailBookingId(data.bookingId)

      var bookingDetail = data.bookingDetail.find(
        (item: any) => item.bookingdetailId == bookingdetailId
      )
      setMaxPeople(bookingDetail.actionTypeDetail[0].maxPeople)
      setGuestInfo(bookingDetail.guestInfo ? bookingDetail.guestInfo : [{}])

      setPeople(bookingDetail.people != '' ? bookingDetail.people : '0')

      setSpaceRentalId(bookingDetail.actionDetail[0].spacerentalId)
      setRentableSpaceId(bookingDetail.actionTypeDetail[0].rentablespaceId)
      setBookingType(bookingDetail.bookingType)

      if (bookingDetail.status == '') {
        setSelectedStatus({value: '0', label: 'Pending'})
      } else {
        var selectedStatus = statusList.filter((item: any) => item.value == bookingDetail.status)

        setSelectedStatus(selectedStatus)
      }

      // setFromDate(formatDate(bookingDetail[0].fromDate))
      // setToDate(formatDate(bookingDetail[0].toDate))
      setFromTime(bookingDetail.fromTime)
      setToTime(bookingDetail.toTime)
      setQuanity(bookingDetail.quantity)
    } else {
    }
  }

  const validate = () => {
    var errotmp: any = {}
    var err = 0
    const regex = /^[0-9]*$/
    const validateCharacters = /^[A-Za-z\s]+$/
    const emailValidate = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

    guestInfo.forEach((guestSlot: any, index: any) => {
      if (
        guestSlot.name.trim() == '' ||
        guestSlot.name.trim() == null ||
        guestSlot.name.trim() == undefined
      ) {
        errotmp[`name${index}`] = t('Name Is Required')
        err = 1
      } else if (!validateCharacters.test(guestSlot.name)) {
        errotmp[`name${index}`] = t('Name Is Not Valid')
        err = 1
      } else if (
        guestSlot.surname.trim() == '' ||
        guestSlot.surname.trim() == null ||
        guestSlot.surname.trim() == undefined
      ) {
        errotmp[`surname${index}`] = t('Sur Name Is Required')
        err = 1
      } else if (!validateCharacters.test(guestSlot.surname)) {
        errotmp[`surname${index}`] = t('Sur Name Is Not valid')
        err = 1
      } else if (
        guestSlot.contactNumber.trim() == '' ||
        guestSlot.contactNumber.trim == null ||
        guestSlot.contactNumber == undefined
      ) {
        errotmp[`contactNumber${index}`] = t('Contact Number Is Required')
        err = 1
      } else if (!regex.test(guestSlot.contactNumber)) {
        errotmp[`contactNumber${index}`] = t('Contact Number Is Not Valid')
        err = 1
      } else if (
        guestSlot.email.trim() != '' &&
        guestSlot.email.trim() != null &&
        guestSlot.email.trim() != undefined &&
        !emailValidate.test(guestSlot.email)
      ) {
        errotmp[`email${index}`] = t('Email Is Not valid')
        err = 1
      }
    })

    setError(errotmp)
    if (err == 0) {
      editGuestList2()
    }
  }

  const editGuestList = async () => {
    var total: any = parseFloat(people)
    if (total > guestInfo.length) {
      toasterrormsg('Please Add Details of Total ' + total + ' People')
    } else if (total < guestInfo.length) {
      toasterrormsg('Please Set People Count to ' + guestInfo.length + ' People')
    } else if (total == '0' && guestInfo.length == '0') {
      toasterrormsg('Please Add People Count And Details Before Updating')
    } else if (Number.isNaN(total)) {
      toasterrormsg('Please Add People Count')
    } else {
      setDisable(true)
      var tmp2 = sessionStorage.getItem('admin')
      // Step 2: Check if the item is not null
      if (tmp2) {
        // Step 3: Parse the JSON string
        var adminData = JSON.parse(tmp2)
        // Step 4: Access the adminId
        var adminId = adminData.adminId
      }

      for (const item of guestInfo) {
        const param = {
          name: item.name.trim(),
          surname: item.surname.trim(),
          contactNumber: item.contactNumber.trim(),
          email: item.email.trim(),
          bookingId: bookingId,
          adminId: adminId,
          guestId: item.guestId,
          bookingdetailId: bookingdetailId,
        }
        var res: any = ''
        res = await fetchData('admin/addEditguest', param)
      }

      if (res.status == '200') {
        BookingListApiCall()
        toastsuccessmsg('Updated Successfully')
        setLoading(false)
        setDisable(false)
      } else {
        setDisable(false)
        toasterrormsg(res.message)
      }
    }
  }
  const editGuestList2 = async () => {
    var tmp2 = sessionStorage.getItem('admin')
    // Step 2: Check if the item is not null
    if (tmp2) {
      // Step 3: Parse the JSON string
      var adminData = JSON.parse(tmp2)
      // Step 4: Access the adminId
      var adminId = adminData.adminId
    }

    var isAggreementMade = 0
    guestInfo.forEach((item: any) => {
      if (item.aggreement == 1) {
        isAggreementMade = 1
      }
    })

    var total: any = parseFloat(people)

    if (total > maxPeople || guestInfo.length > maxPeople) {
      toasterrormsg(`Maximum Guest Limit Is  ${maxPeople}.`)
      return false
    } else if (isAggreementMade == 0) {
      if (total > guestInfo.length) {
        toasterrormsg('Please Add Details of Total ' + total + ' People')
      } else if (total < guestInfo.length) {
        toasterrormsg('Please Set People Count to ' + guestInfo.length + ' People')
      } else if (total == '0' && guestInfo.length == '0') {
        toasterrormsg('Please Add People Count And Details Before Updating')
      } else if (Number.isNaN(total)) {
        toasterrormsg('Please Add People Count')
      }
    }

    setDisable(true)
    setLoading(true)
    const param = {
      updateStatus: '1',
      bookingId: String(bookingId),
      bookingdetailId: bookingdetailId,
      bookingDetailStatus: selectedStatus ? selectedStatus.value : '',
      adminId: adminId,
      actionTypeId: rentableSpaceId ? String(rentableSpaceId) : '',
      // fromDate: fromDate,
      // toDate: toDate,
      fromTime: fromTime == '' ? '00:00' : String(fromTime),
      toTime: toTime == '' ? '00:00' : String(toTime),
      quantity: String(quantity),
      bookByHour: bookingType == 'byHour' ? '0' : '1',
      people: people != '' ? people : '',
    }

    var res = await fetchData('admin/editrentablespacebooking', param)

    if (res.status == '200') {
      BookingListApiCall()
      editGuestList()
      setLoading(false)
      setDisable(false)
    } else {
      toasterrormsg(res.message)
      setDisable(false)
      setLoading(false)
    }
  }

  const spaceRentalDetailApiCall = async () => {
    var param: any = {
      spacerentalId: String(spacerentalId),
    }
    var response: any = await fetchData('vendor/public/spaceDetails', param)

    if (response.status == '200') {
      var rentableSpaceList = response.data[0]['rentablespace']
      var opt: any = []
      rentableSpaceList.map((val: any) => {
        opt.push({value: val.rentablespaceId, label: val.en_name})
      })

      setRentableSpaceList(opt)
      var selectedRentableSpace = opt.filter((item: any) => item.value == rentableSpaceId)
      setSelectedRentableSpace(selectedRentableSpace[0])
    } else {
    }
  }

  useEffect(() => {
    spaceRentalDetailApiCall()
  }, [spacerentalId])

  const [error, setError] = useState([
    {
      firstName: '',
      surName: '',
      email: '',
      contactNumber: '',
    },
  ]) as any

  // const handleGuestChange = (index: number, field: string, value: string) => {
  //   var newGuests: any = [...guestInfo]
  //   newGuests[index][field] = value
  //   setGuestInfo(newGuests)
  // }

  const handleGuestChange = (index: number, field: string, value: any) => {
    let newGuests = [...guestInfo]

    if (field === 'aggreement') {
      newGuests = newGuests.map((guest, i) => ({
        ...guest,
        aggreement: i === index ? value : 0,
      }))
    } else {
      newGuests[index][field] = value
    }

    setGuestInfo(newGuests)
  }

  useEffect(() => {
    BookingListApiCall()
  }, [])

  return (
    <>
      <ToastContainer />
      <PageTitle breadcrumbs={[]}>
        {t("Edit Guest List")}
      </PageTitle>
      <div className='d-flex flex-column flex-column-fluid'>
        <div id='kt_app_content' className='app-content flex-column-fluid'>
          <div className='form d-flex flex-column flex-lg-row'>
            <div className='d-flex flex-column flex-row-fluid gap-7 gap-lg-10'>
              <div className='tab-content'>
                <div
                  className='tab-pane fade show active'
                  id='kt_ecommerce_add_product_general'
                  role='tab-panel'
                >
                  <div className='d-flex flex-column'>
                    <div className='card card-flush py-4'>
                      <div className='card-header d-flex'>
                        <div className='card-title'>
                          <h2>{t("Guest List")}</h2>
                        </div>
                        {/* <!--end::Card title--> */}
                      </div>
                      <div className='card-body pt-0'>
                        <div className='row'>
                          <div className='col-lg-4 my-3'>
                            {/* <!--begin::Label--> */}
                            <label className='required fs-4 form-label'> {t("Total People")}</label>
                            {/* <!--end::Label--> */}
                            {/* <!--begin::Input--> */}
                            <input
                              type='text'
                              name='people'
                              className='form-control mb-2'
                              placeholder={t('People')}
                              value={people}
                              onChange={(e) => {
                                setPeople(e.target.value)
                              }}
                            />
                            {/* <!--end::Input--> */}
                          </div>
                        </div>
                      </div>
                      {guestInfo.length > 0 ? (
                        guestInfo.map((item: any, index: any) => {
                          return (
                            <div key={index}>
                              <div className='card-body pt-0'>
                                {/* <!--begin::Input group--> */}
                                <div className='row mb-0 '>
                                  <div className='col-lg-4 '>
                                    {/* <!--begin::Label--> */}
                                    <label className='required fs-4 form-label'>{t("First Name")}</label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <input
                                      type='text'
                                      name='name'
                                      className='form-control mb-2'
                                      placeholder={t('First Name')}
                                      value={item.name}
                                      onChange={(event: any) =>
                                        handleGuestChange(index, 'name', event.target.value)
                                      }
                                    />
                                    {/* <!--end::Input--> */}
                                    <label className='text-danger fw-bold'>
                                      {error[`name${index}`] || ''}
                                    </label>
                                  </div>
                                  <div className='col-lg-4 '>
                                    {/* <!--begin::Label--> */}
                                    <label className='required fs-4 form-label'>{t("Surname")}</label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <input
                                      type='text'
                                      name='surname'
                                      className='form-control mb-2'
                                      placeholder={t('Surname')}
                                      value={item.surname}
                                      onChange={(event: any) =>
                                        handleGuestChange(index, 'surname', event.target.value)
                                      }
                                    />
                                    {/* <!--end::Input--> */}
                                    <label className='text-danger fw-bold'>
                                      {error[`surname${index}`] || ''}
                                    </label>
                                  </div>

                                  <div className='col-lg-4'>
                                    {/* <!--begin::Label--> */}
                                    <label className='required fs-4 form-label'>
                                      {t("Contact Number")}
                                    </label>

                                    <input
                                      type='text'
                                      name='contactNumber'
                                      className='form-control mb-2'
                                      placeholder={t('Contact Number')}
                                      value={item.contactNumber}
                                      onChange={(event: any) =>
                                        handleGuestChange(
                                          index,
                                          'contactNumber',
                                          event.target.value
                                        )
                                      }
                                    />
                                    <label className='text-danger fw-bold'>
                                      {error[`contactNumber${index}`] || ''}
                                    </label>
                                  </div>
                                  {/* <!--end::Input--> */}
                                </div>
                              </div>

                              <div className='card-body pt-0'>
                                <div className='row mb-0'>
                                  <div className='col-lg-4 '>
                                    <label className='required fs-4 form-label'>{t("Email")}</label>

                                    <input
                                      type='text'
                                      name='email'
                                      className='form-control '
                                      placeholder={t('Email')}
                                      value={item.email}
                                      onChange={(event: any) =>
                                        handleGuestChange(index, 'email', event.target.value)
                                      }
                                    />
                                    {/* <!--end::Input--> */}
                                    <label className='text-danger fw-bold'>
                                      {error[`email${index}`] || ''}
                                    </label>
                                  </div>

                                  {/* <!--end::Input--> */}
                                </div>
                                <div className='fw-bold'>
                                  {' '}
                                  <input
                                    type='checkbox'
                                    className='form-check-input'
                                    value={item.aggreement}
                                    checked={item.aggreement == 1 ? true : false}
                                    onChange={(event: any) =>
                                      handleGuestChange(
                                        index,
                                        'aggreement',
                                        event.target.value == 1 ? 0 : 1
                                      )
                                    }
                                  />{' '}
                                  {t("I Take Full Responsibility For the Actions And Manners Of All Other Guests That Accompany Me.")}
                                </div>
                                <div className='d-flex justify-content-end gap-3'>
                                  <div>
                                    <button
                                      className='btn btn-danger'
                                      onClick={() => removeGuest(item.guestId, index)}
                                    >
                                      <FontAwesomeIcon icon={faMinus} />
                                    </button>
                                  </div>
                                  <div>
                                    <button className='btn btn-success' onClick={addGuest}>
                                      <FontAwesomeIcon icon={faPlus} />
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          )
                        })
                      ) : (
                        <>
                          <div className='text-center '>
                            <div className='d-flex justify-content-center align-items-center flex-column '>
                              <h2 className='fs-2x fw-bold '>
                                {t("Sorry Currently There are no Guests")}
                              </h2>
                            </div>
                          </div>
                          <div className='d-flex justify-content-center p-5'>
                            <img
                              className='mw-100 mh-300px'
                              alt=''
                              src={toAbsoluteUrl('/media/illustrations/sketchy-1/2.png')}
                            />
                          </div>
                        </>
                      )}
                      <div className='d-flex justify-content-center'>
                        {guestInfo.length == 0 ? (
                          <>
                            <button className='btn btn-success' onClick={addGuest}>
                              {t("Add Guest")}
                            </button>
                          </>
                        ) : (
                          ''
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className='d-flex justify-content-end'>
                {/* <!--begin::Button--> */}
                <Link
                                    to={getEncryptedRoute('../viewspacebookingdetails/', {menuId:menuId})}

                  id='kt_ecommerce_add_product_cancel'
                  className='btn btn-light me-5'
                  state={{bookingId: detailBookingId}}
                >
                  {t("Cancel")}
                </Link>

                <button
                  onClick={() => {
                    validate()
                  }}
                  type='button'
                  disabled={disable}
                  className='btn btn-primary'
                >
                  <span className='indicator-label'>{t("Save")}</span>
                  {loading && (
                    <span
                      className='spinner-border spinner-border-sm mx-2'
                      role='status'
                      aria-hidden='true'
                    ></span>
                  )}
                </button>

              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export {GuestInfo}
